import { Button } from '@e2n/ui/v2';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import {
  faArrowDownShortWide,
  faArrowUpShortWide,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views.ts';

export function SortierungButton({
  view,
  variant,
}: {
  view: View;
  variant: 'ghost' | 'ghost-on-grey';
}) {
  const { t } = useTranslation();
  const {
    store: { ui, setUebersichtSortierung, setKalenderSortierung },
  } = useRotationsplanFeatureContext();

  const istSortierungAufsteigend =
    view === 'planung'
      ? ui.kalender.istSortierungAufsteigend
      : ui.uebersicht.istSortierungAufsteigend;

  const setSortierung =
    view === 'planung' ? setKalenderSortierung : setUebersichtSortierung;

  function changeSortierung() {
    setSortierung(!istSortierungAufsteigend);
  }

  return (
    <Button
      className="flex items-center gap-2 w-fit"
      variant={variant}
      onClick={changeSortierung}>
      <FontAwesomeIcon
        className="size-4"
        icon={
          istSortierungAufsteigend ? faArrowDownShortWide : faArrowUpShortWide
        }
      />
      <div className="hidden md:flex">
        {t('domain.mitarbeiter.rotationsplan.sortierung')}
      </div>
    </Button>
  );
}
